import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ClerkProvider, SignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { AppLayout } from './layouts/AppLayout';
import { HomePage } from './pages/HomePage';
import { TaskApprovalPage } from './pages/TaskApprovalPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import { OperationsPage } from './pages/OperationsPage';
import { VaultPage } from './pages/VaultPage';
import { SettingsPage } from './pages/SettingsPage';
import { HistoryPage } from './pages/HistoryPage';

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

export default function App() {
  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <SignedOut>
        <div
          className="flex items-center justify-center h-screen"
          style={{ background: '#0e0e11' }}
        >
          <SignIn />
        </div>
      </SignedOut>
      <SignedIn>
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route index element={<HomePage />} />
              <Route path="operations" element={<OperationsPage />} />
              <Route path="operations/:id" element={<TaskDetailPage />} />
              <Route path="operations/:id/approve" element={<TaskApprovalPage />} />
              <Route path="vault" element={<VaultPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SignedIn>
    </ClerkProvider>
  );
}
